import { FC } from 'react';
import { format } from 'date-fns';
import { dateFormat } from 'constants/formats';
import { useTranslate } from 'hooks/useTranslate';

import { isActiveEncumbrance } from 'modules/partners/utils/isActiveEncumbrance';

import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const DatesSection: FC = () => {
  const { t } = useTranslate();
  const { data } = useEncumbranceDetailsPage();

  const isActive = isActiveEncumbrance({
    encumbrance: {
      endDate: data?.endDate,
    },
  });

  return (
    <div className="encumbrance-details__dates">
      <div className="encumbrance-details__date-card">
        <p className="encumbrance-details__date-label">{t('StartDate')}</p>
        <p className="encumbrance-details__date-value">
          {data?.date ? format(new Date(data.date), dateFormat) : '-'}
        </p>
      </div>

      <div className="encumbrance-details__date-card">
        <p className="encumbrance-details__date-label">{t('EndDate')}</p>
        <p
          className={`encumbrance-details__date-value ${
            !data.endDate ? 'encumbrance-details__date-value--muted' : ''
          }`}
        >
          {data?.endDate ? format(new Date(data.endDate), dateFormat) : '-'}
        </p>
      </div>

      <div className="encumbrance-details__date-card">
        <p className="encumbrance-details__date-label">{t('Status')}</p>
        <span
          className={`badge badge-dim badge-${isActive ? 'success' : 'danger'}`}
        >
          {isActive ? t('Active') : t('Inactive')}
        </span>
      </div>
    </div>
  );
};

export default DatesSection;
